/*
 * The defaultTheme.
 *
 * currently set as the clientPortalTheme.
 *
 * The `theme` object (the default theme) keys may not always be an exhaustive
 * list of sections used, although it should try to be.
 */
export { theme, useClientPortalTheme as useDefaultTheme } from './clientPortal';
